<template>
 <div class="d-flex">
  <div class="col-md-3" v-if="!details">
    <Search :calcularTotalDespesaViagemUsuario="calcularTotalDespesaViagemUsuario" @onLoadFuncionario="getDespesasViagemDiretoria"></Search>
  </div>
  <div class="col-md-9" v-if="!details">
    <Tables ref="tableGrid"
        :columns="[
                  'Lote',
                  'Data da despesas',
                  'Categoria',
                  'Subcategoria',
                  'Quantidade',
                  'Valor',
                ]"
        :showReload="false"
        v-on:Load="onLoad"
        :showButtonNew="true"
        @check="eventcheck"
        :showCheckInput="true "
        :newHeaderStatus="true"
        :showHeader="true"
        >
        <tr v-for="data in dataexpenses" :key="data.id">
            <TableColumn :IsCustomButtons="true"><input :id="data.id" type="checkbox" class="w-50"></TableColumn>
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data)" :status="1" :value="data.despesasViagemLote.lote" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data)" :status="1" :value="data.dataRegistroDespesaFormatada" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data)" :status="1" :value="data.categoriaDescricao" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data)" :status="1" :value="data.getEnumSubCategoriaGeral" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data)" :status="1" :value="data.quantidade" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data)" :status="1" :value="data.valorFormatado"/>
        </tr>
        <template #ButtonsAprova>
          <div class="buttonaprova" v-if="verificardiretoria">
            <button class="btn-rep" @click="disaApprove" ><i class="fas fa-thumbs-down"></i> Reprovar</button>
            <button class="btn-appr" @click="approve"><i class="fas fa-thumbs-up"></i> Aprovar</button>
          </div>
        </template>
    </Tables>
  </div>
  <div class="col-md-12" v-if="details">
      <Details :dataExpenseDetails="dataExpenseDetails"></Details>
    </div>
 </div>
</template>

<script>
import Search from '../trevelexpenseemployee/components/search/search.vue'
import Details from '../trevelexpenseemployee/components/details/details.vue'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import { loading } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'

export default {
  name: 'BoardTrevelExpenseEmployee',
  components: {Search, Details},
  mixins: [ActionsForm],
  data () {
    return {
      dataexpenses: [],
      details: false,
      dataFormSearch: {
        categoria: null,
        subcategoria: null,
        situacao: null
      },
      despesaviagemid: null,
      dataExpenseDetails: {}
    }
  },
  computed: {
    calcularTotalDespesaViagemUsuario: function () {
      let total = 0
      this.dataexpenses.forEach((Element) => {
        total += Element.valor
      })
      return total
    },
    verificardiretoria () {
      if (this.dataFormSearch === undefined) return true
      if (this.dataFormSearch.situacao === null || this.dataFormSearch.situacao === undefined) return true
      return parseInt(this.dataFormSearch.situacao) === 2
    }
  },
  mounted () {
    this.getDespesasViagemDiretoria()
  },
  methods: {
    getDespesasViagemDiretoria (data) {
      loading.push()
      Object.assign(this.dataFormSearch, data)
      TravelExpenseRepository.GetDespesasViagemDiretoria(this.dataFormSearch)
        .then((Response) => {
          this.$refs.tableGrid.LoadAllByData(Response)
          loading.pop()
          this.dataexpenses = Response.data.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    onSelect (data) {
      if (data.adiantamento) return
      this.despesaviagemid = data.id
      this.GetByidDetails()
    },
    GetByidDetails () {
      loading.push()
      TravelExpenseRepository.GetByidDetails(this.despesaviagemid)
        .then((Response) => {
          loading.pop()
          this.dataExpenseDetails = Response.data
          this.details = true
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    eventcheck (e) {
      let arrayids = this.dataexpenses.map((Element) => Element.id)
      arrayids.forEach((Element) => {
        let input = document.getElementById(Element)
        if (input !== undefined || input !== null) input.checked = e.checked
      })
    },
    getchecked () {
      let arrayids = this.dataexpenses.map((Element) => Element.id)
      let lstapprove = []
      arrayids.forEach((Element) => {
        let input = document.getElementById(Element)
        if ((input !== undefined || input !== null) && input.checked === true) {
          lstapprove.push(Element)
        }
      })
      return lstapprove
    },
    approve () {
      loading.push()
      let lstdespesa = this.getchecked()
      TravelExpenseRepository.ApproveBoard(lstdespesa)
        .then((Response) => {
          this.getDespesasViagemDiretoria()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    disaApprove () {
      loading.push()
      let lstdespesa = this.getchecked()
      TravelExpenseRepository.DisaApproveBoard(lstdespesa)
        .then((Response) => {
          this.getDespesasViagemDiretoria()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    }
  }

}
</script>

<style scoped>
 .buttonaprova{
    height: 45px;
    display: flex;
  }
  .btn-rep{
    width: 10vw;
    background: red;
    margin-right: 5px;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
.btn-appr{
    width: 10vw;
    background: #008144;
    color: white;
    margin-left: 5px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
  .btn-rep:hover{
    background: rgb(179, 1, 1);

  }
.btn-appr:hover{
    background: #01532d;
  }

</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/boardtrevelexpenseemployee/boardtrevelexpenseemployee.vue